var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { BreadcrumbItem } from './BreadcrumbItem';
import { DASHBOARD, DASHBOARD_LABEL } from '../app-location';
import { useBasename } from 'react-admin';
export var DashboardBreadcrumbItem = function (_a) {
    var children = _a.children, _b = _a.label, label = _b === void 0 ? DASHBOARD_LABEL : _b, props = __rest(_a, ["children", "label"]);
    var basename = useBasename();
    var to = basename !== '' ? "".concat(basename) : '/';
    return (React.createElement(BreadcrumbItem, __assign({ name: DASHBOARD, to: to, label: label }, props), children));
};
